import { dataLayerPush } from '../../global/datalayers/datalayers';
import cookies from './cookies';

// kentico test AB - for returning users (with BED cookie - prlstabvariant) - all places
const testAB = () => {
    const testABCookie = cookies.read('prlstabvariant');
    const testABIsReturningUserSession = sessionStorage.getItem('testABIsReturningUserSession');

    if (testABCookie && !testABIsReturningUserSession) {
        dataLayerPush('kentico_ab_test', {
            evParam1: testABCookie,
            evParam2: 'returning_user'
        });
        sessionStorage.setItem('testABIsReturningUserSession', 1);
    }
};

export default testAB;
